import Services from "../../services";

class BayarDPVendor {
  // API SERVER
  get(params) {
    return Services.get("hrdu/approval_dp_customer/list", { params });
  }

  getHistory(params) {
    return Services.get("hrdu/approval_dp_customer/history/list", { params });
  }

  getSingle(params) {
    return Services.get("hrdu/approval_dp_customer/detail", { params });
  }

  approve(data) {
    return Services.post("hrdu/approval_dp_customer/approve", data);
  }
}

export default new BayarDPVendor();
